import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { Feature } from "ol";
import Point from "ol/geom/Point";
import {Icon, Text, Style, Fill, Stroke} from 'ol/style';
import * as olProj from 'ol/proj';
import * as esdmGridReference from "esdm-gridreference";


export class LhlpMapContextMenu extends  MapContextMenu {

    public addMarker = (coordinate: [number, number]): void => {

        var coords = olProj.transform(coordinate, this._map.options.dataProjection, 'EPSG:27700');
        var ngr = new esdmGridReference.OSGB();
        ngr.SetGridCoordinates(coords[0], coords[1]);
        let iconText: string = ngr.GetGridRef(5).split(' ').join(''); //remove all spaces 

        let iconStyle = new Style({
            text: new Text({
                    text: '\uf3c5',
                    font: '900 35px "Font Awesome 6 Pro"',
                    textBaseline: 'bottom',
                    offsetY: 2,
                    offsetX: -1,
                    fill: new Fill({
                        color: 'black',
                    })
            })                
        });

        let textStyle =  new Style({
            text: new Text({
                offsetY: 25,
                textBaseline: 'bottom',
                text: iconText,
                font: '15px Open Sans,sans-serif',
                fill: new Fill({ color: '#111' }),
                stroke: new Stroke({ color: '#eee', width: 2 })
            })
        });
            
        let iconFeature = new Feature({
            type: 'removable',
            geometry: new Point(coordinate)
        });

        let textFeature = new Feature({
            type: 'removable',
            geometry: new Point(coordinate)
        });

        iconFeature.setStyle(iconStyle);
        textFeature.setStyle(textStyle);
        this._vectorLayer.getSource().addFeature(iconFeature);
        this._vectorLayer.getSource().addFeature(textFeature);
    }​​​

}